import { createSlice} from "@reduxjs/toolkit";

let initialState = {
    allModulesList:[],
    reviewModuleData: null
}

const moduleSlice = createSlice({
    name:"moduleSlice",
    initialState,
    reducers:{
        addModules:(state,action)=>{
           state.allModulesList = action.payload
        },
        removeModuleList:(state)=>{
            state.allModulesList = []
        },
        addReviewModuleData:(state,action)=>{
            let data = {...state.reviewModuleData, ...action.payload};
            state.reviewModuleData= data
        },
        remoteReviewModuleData:(state)=>{
            state.reviewModuleData=null
        }
    }
});

export const {addModules, removeModuleList, addReviewModuleData, remoteReviewModuleData }  =  moduleSlice.actions;
export default moduleSlice.reducer;